/**
 * UserProfileActions Component
 * Handles delete confirmation modal and success message
 */

import React from "react";
import Modal from "react-modal";

const UserProfileActions = ({
  showConfirmation,
  showSuccessMessage,
  onConfirmDelete,
  onCancelDelete,
}) => {
  return (
    <>
      {showConfirmation && (
        <Modal
          isOpen={showConfirmation}
          onRequestClose={onCancelDelete}
          contentLabel="Confirmation Modal"
          style={{
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              maxHeight: "80vh",
              overflow: "auto",
            },
          }}
        >
          <p>Are you sure you want to delete?</p>
          <div>
            <button onClick={onConfirmDelete}>OK</button>
            <button onClick={onCancelDelete}>Cancel</button>
          </div>
        </Modal>
      )}

      {showSuccessMessage && (
        <div className="success-message">Profile deleted successfully!</div>
      )}
    </>
  );
};

export default UserProfileActions;
